import { FieldMuter } from '../types/form';

const textFieldMutator = (changeHandler: FieldMuter, path: string) => (event) =>
	changeHandler(event.target.value !== '' ? event.target.value : null, path);

const dateFieldMutator = (changeHandler: FieldMuter, path: string) => (date) =>
	changeHandler(date || null, path);

export { textFieldMutator, dateFieldMutator };
